module.exports = __webpack_public_path__ + "img/lever00.efb9767c.png";